import { Box, styled } from "@mui/material";

export const StyledCard = styled(Box)(({ theme }) => ({
  borderRadius: "10px", 
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  boxSizing: "border-box",
  border: `3px solid ${theme.contrast.lighter}`,
  width: "100%",
  paddingBottom: "2rem",
  ".head": {
    background: theme.color.main,
    display: "flex",
    marginBottom: ".5rem",
    alignItems: "center",
    color: theme.color.background,
    padding: ".5rem 2rem",
    justifyContent: "space-between",
    h3: {
      fontWeight: "bold",
    },
    ".button": {
      cursor: "pointer",
      "&:hover": {
        color: theme.color.dark,
        background: "none",
      },
    },
    button: {
      color: theme.color.background,
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      border: `2px solid ${theme.color.dark}`,
      padding: "0.25rem 2rem",
    },
  },
}));
